module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/babel-runtime/core-js/array/from.js
// module id = 1092
// module chunks = 0